import Vue from 'vue'

import App from './App.vue'
//import './quasar'
import router from './router/index'
import store from './store/index'
import './registerServiceWorker'
import './assets/css/AHAMQuasarTheme.css'

import Vuelidate from "vuelidate";
import './styles/quasar.styl'
import 'quasar/dist/quasar.ie.polyfills'
import iconSet from 'quasar/icon-set/fontawesome-v5.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import '@quasar/extras/ionicons-v4/ionicons-v4.css'
import '@quasar/extras/mdi-v3/mdi-v3.css'
import '@quasar/extras/eva-icons/eva-icons.css'

import VueSimpleAlert from "vue-simple-alert";

import VueFriendlyIframe from 'vue-friendly-iframe';

import httpClient from './services/httpClient'
import datadogRum from './datadog'

Vue.component('vue-friendly-iframe', VueFriendlyIframe);

Vue.use(VueSimpleAlert);

// Initiate httpClient
Vue.prototype.$httpClient = httpClient
store.$httpClient = httpClient // register here so this http instance could eb used in vuex also

// Initiate dataDogRum
Vue.prototype.$datadogRum = datadogRum

import {
  Quasar, 
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QCard,
  QCardSection,
  QCardActions,
  QDialog,
  QForm,
  QInput,
  ClosePopup,
  QAjaxBar,
  QExpansionItem,
  QToggle,
  QSelect,
  QOptionGroup,
  QBtnToggle,
  QAvatar,
  QUploader,
  QSeparator,
  Dialog,
  QCheckbox,
  QTooltip,
  QBadge,
  QDate,
  QPopupProxy, 
  QStepper,
  QStep,
  QStepperNavigation,
  Notify,
  QTable,
  QTh,
  QTr,
  QTd,
  QChip,
  Loading,
  QBanner,
  QField,
  QRadio,
  QMenu,
  QFooter,
  QCarousel,
  QCarouselControl,
  QCarouselSlide,
  QImg,
  QSpinner
} from 'quasar'

import i18n from './i18n'


Vue.use(Vuelidate);
Vue.use(Quasar, {
  config: {},
  components: {
    QSpinner,
    QLayout,
    QHeader,
    QFooter,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QCard,
    QCardSection,
    QCardActions,
    QDialog,
    QForm,
    QInput,
    QAjaxBar,
    QExpansionItem,
    QToggle,
    QSelect,
    QOptionGroup,
    QBtnToggle,
    QAvatar,
    QUploader,
    QSeparator,
    QCheckbox,
    QTooltip,
    QBadge,
    QDate,
    QPopupProxy,
    QStepper,
    QStep,
    QStepperNavigation,
    QTable,
    QTh,
    QTr,
    QTd,
    QChip,
    QBanner,    
    QField,
    QRadio,
    QMenu,
    QCarousel,
    QCarouselControl,
    QCarouselSlide,
    QImg
  },
  directives: {
    ClosePopup
  },
  plugins: {
    Dialog,
    Notify,
    Loading
  },
  iconSet: iconSet
 })

console.log('App version', process.env.VUE_APP_VERSION)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
